<template>
  <div class="download bg-white" @click="hidedraft()">
    <headerCom>
      <div class="flex-lm" slot="act">
        <div class="work-acts flex-lm white-font font-size14" v-if="tableData.length > 0">
          <!-- <a class="flex-cm work-act-single white-font font-size14" :href="'https://pfotoo.com/index.php?service=App.Qiniu.Down&detail=1&type=fold'+getsign()+'&id='+imgidstr" v-if="workidarr.length>0 && workidarr.length<=5">
            <div class="bg-green botton-content flex-cm only-click-button">
              <img src="https://assets.pfotoo.com/pc/img/down.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
              <span>批量下载</span>
            </div>
            </a> -->
          <el-popover v-if="draftinfo.activityType != 'Word'" placement="top-start" width="300" trigger="hover">
            <div slot="reference" class="flex-cm work-act-single white-font font-size14">
              <div class="botton-content flex-cm only-click-button bg-green white-font">
                <img src="https://assets.pfotoo.com/pc/img/down.svg"
                  style="width: 14px;height: 14px;margin-right: 5px;" />
                <span>下载文件</span>
              </div>
            </div>
            <div style="cursor: pointer;padding: 10px 0;">
              <!--
                <el-link class="flex-lt black-font font-size14 font-bold disabled"
                         v-if="hasSselectedAll && total>pageSize"
                         style="padding-bottom:5px;font-weight: bold">
                  <span>批量下载(只能下载当前表格数据)</span>
                </el-link>
                -->
              <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                :class="draftinfo.type != 4 ? '' : 'disabled-gray'" @click="draftinfo.type != 4 && downDialog()">
                <span>批量下载(选中{{ hasSselectedAll ? total : workidarr.length }}个投稿)</span>
              </el-link>
              <div class="gray-font font-size12 flex align-center">
                下载量少、快速下载，选我
                <img src="https://assets.pfotoo.com/pc/up.png" style="width: 9px;height: 10px;margin-left: 5px;"></img>
              </div>
              <div style="margin-top: 20px;">
                <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                  :class="(draftinfo.type != 4 && isDownAllButton()) ? '' : 'disabled-gray'"
                  @click="(draftinfo.type != 4 && isDownAllButton()) && downAllDialog()">
                  <span>打包下载(选中{{ hasSselectedAll ? total : workidarr.length }}个投稿)</span>
                </el-link>
                <div class="gray-font font-size12 flex align-center">
                  下载量大、自定义名称，选我
                  <img src="https://assets.pfotoo.com/pc/up.png"
                    style="width: 9px;height: 10px;margin-left: 5px;"></img>
                </div>
              </div>
            </div>
          </el-popover>

          <el-popover v-if="id != ''" placement="top-start" width="300" trigger="hover">
            <div slot="reference" class="flex-cm work-act-single white-font font-size14">
              <div class="botton-content flex-cm only-click-button bg-green white-font">
                <img src="https://assets.pfotoo.com/pc/img/output.svg"
                  style="width: 14px;height: 14px;margin-right: 5px;" />
                <span>导出Excel</span>
              </div>
            </div>
            <div style="cursor: pointer;padding: 10px 0;">
              <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                @click="downexcel()">
                <span>导出选中(选中{{ this.workidarr.length }}个投稿)</span>
              </el-link>
              <div style="margin-top: 20px;">
                <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                  @click="downexcelAll()">
                  <span>导出全部(全部{{ total }}个投稿)</span>
                </el-link>
              </div>
            </div>
          </el-popover>
          <election :activityId="id"></election>
          <div v-if="draftinfo.type != 4" @click="downAllDialog('all')"
            class="flex-cm work-act-single white-font font-size14">
            <div class="botton-content flex-cm only-click-button bg-green white-font">
              <img src="https://assets.pfotoo.com/pc/img/down.svg"
                style="width: 14px;height: 14px;margin-right: 5px;" />
              <span>下载全部</span>
            </div>
          </div>
        </div>
      </div>
      <div class="search flex-lm" slot="search">
        <input placeholder="输入编号/作者署名/作品名称/联系方式…" class="search-input" @focus="changefoucusval" @blur="changefoucusval"
          :style="{ 'width': inputfocus == true ? 255 + 'px' : 100 + 'px', }" v-model="searchval"
          @keyup.enter="search" />
        <div class="search-button flex-vc" @click.stop="search">
          <i class="el-icon-search"></i>
        </div>
      </div>
    </headerCom>
    <div class="down-content">
      <div class="flex-lm">
        <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
      </div>
      <div class="total-data flex-lm font-5d5d5d font-size12 text-500" style="" v-if="statistics">
        <div class="flex-lm draft-total-data cursor">
          <trafficPopover :draftinfo="draftinfo" ref="trafficPopover"></trafficPopover>
          <!--
          <div>文件总大小：<span class="font-size14">
              {{MG(statistics.materialSize/1+statistics.enclosureSize/1)}}
            </span></div>
            -->
          <div>投稿数量：<span class="font-size14">{{ statistics.submissionCount || 0 }}</span></div>
          <div>投稿人数：<span class="font-size14">{{ statistics.submissionAuthorCount || 0 }}</span></div>
          <!--
          <div>浏览数量：<span class="font-size14">{{statistics.viewCount || 0}}</span></div>
          <div>点赞数量：<span class="font-size14">{{statistics.likeCount || 0}}</span></div>
          <div>投票数量：<span class="font-size14">{{statistics.votes || 0}}</span></div>
          <div>评论数量：<span class="font-size14">{{statistics.commentCount || 0}}</span></div>
          -->
          <el-popover placement="bottom-start" width="360" trigger="hover">
            <div slot="reference" class="text-blue margin-left">
              活动数据统计
            </div>
            <div style="line-height: 300%;padding: 10px;">
              <div class="flex align-center">
                剩余下载额度：<span class="font-size14">
                  {{ MG(draftinfo.residualDownloadTraffic) }}
                </span><img src="https://assets.pfotoo.com/image/notice.svg" class="margin-left-sm"
                  style="width: 12px;height: 12px;"></img>
              </div>
              <div class="flex flex-wrap">
                <div style="width: 60%;">文件总大小：<span class="font-size14">
                    {{ MG(statistics.materialSize / 1 + statistics.enclosureSize / 1) }}
                  </span></div>
                <div>投稿数量：<span class="font-size14">{{ statistics.submissionCount || 0 }}</span></div>
                <div style="width: 60%;">投稿人数：<span class="font-size14">{{ statistics.submissionAuthorCount || 0
                }}</span>
                </div>
                <div>浏览数量：<span class="font-size14">{{ statistics.viewCount || 0 }}</span></div>
                <div style="width: 60%;">点赞数量：<span class="font-size14">{{ statistics.likeCount || 0 }}</span></div>
                <div>投票人数：<span class="font-size14">{{ statistics.voters || 0 }}</span></div>
                <div>评论数量：<span class="font-size14">{{ statistics.commentCount || 0 }}</span></div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div v-if="hasSelectedTip && workidarr.length > 0 && pageRows > 0"
        class="selected-data flex-lr font-5d5d5d font-size12 padding-lr">
        <div class="flex-vc" style="width: 100%;">
          <el-link type="success" @click="switchSelectedAll" v-if="hasSselectedAll">
            <span style="color:#5d5d5d;">已勾全部{{ total }}个，{{ selectedAllSize > 0 ? MG(selectedAllSize) : '...'
            }}；</span>
            <span class="text-red">取消勾选</span>
          </el-link>
          <el-link type="success" @click="switchSelectedAll" v-else="">
            <span style="color:#5d5d5d;">已勾选本页{{ workidarr.length }}个，{{ MG(workidsize) }}；</span>
            <span class="text-red">勾选全部{{ total }}个</span>
          </el-link>
        </div>
        <div class="el-icon-close text-xl text-white" style="min-width: 20px;" @click="hideSelectedTip"></div>
      </div>
      <div style="width: 100%;padding-right:15px;box-sizing: border-box;">
        <div ref="allTable">
          <div style="padding: 23px 0 20px 20px;" ref="searchBlock" v-if="false">
            <tab :id="id" :auto="true" v-if="id != ''" v-on:tellgroup="tellgroup"
              :selectedIndex="modelvalue == 1 ? 0 : -1">
              <!-- <div style="position: absolute;right: 20px;top: 0;">
                  <template>
                    <el-select v-model="modelvalue" placeholder="请选择" @change="selectorder($event)">
                      <el-option
                        :size="180"
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
</div> -->
            </tab>
            <div class="detail-unit-list flex-rs" style="padding-top: 5px;"
              v-if="draftinfo.activityType == 'Mixin' || (draftinfo.activityAuth && draftinfo.activityAuth.isTrack == 1)">
              <template v-if="draftinfo.activityType == 'Mixin'">
                <div
                  :class="['detail-unit-single  font-size14 flex-cm', activeMaterialType == item.activityMaterialType ? 'green-font unit-green-font' : 'gray-font']"
                  v-for="(item, index) in draftinfo.activityMaterialTypeRefs" :key="index" v-if="item.enable == 1"
                  @click="selectMaterialType(item.activityMaterialType)">{{ materialTypes[item.activityMaterialType] }}
                </div>
              </template>
              <template v-if="draftinfo.activityAuth.isTrack == 1">
                <div
                  :class="['detail-unit-single  font-size14 flex-cm', activeTrackId == item.id ? 'green-font unit-green-font' : 'gray-font']"
                  v-for="(item, trackIndex) in draftinfo.trackList" :key="item.id" @click="selectTrackId(item.id)">
                  {{ item.name }}</div>
              </template>
            </div>

            <div class="detail-unit-list flex-rs" v-if="unitlist.length > 0">
              <div
                :class="['detail-unit-single  font-size14 flex-cm', item.isactive ? 'green-font unit-green-font' : 'gray-font']"
                v-for="(item, index) in unitlist" @click="selectunit(index)">{{ item.name }}</div>
            </div>
          </div>
          <div class="table-total flex-lr bg-light-gray black-font font-size12">
            <optionPlane ref="optionPlane" :draftinfo="draftinfo" v-if="draftinfo.activityId" @event="optionPlaneEvent">
            </optionPlane>
            <div class="font-size14 gray-font smooth">筛选出{{ total }}个投稿</div>

            <div v-if="false" class="table-total flex-lm bg-light-gray black-font font-size12">
              <div class="flex-lm" style="margin-right: 35px;">
                <div class="font-size12 gray-font" style="margin-right: 10px;">时间选择</div>
                <template>
                  <el-select v-model="modeltime" placeholder="请选择" @change="selecttime($event)" style="width: 150px;">
                    <el-option size="mini" v-for="item in timeoption" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="block" :style="{ marginLeft: 10 + 'px', display: modeltime == 100 ? 'flex' : 'none' }">
                    <el-date-picker @change="selectdate" format="yyyy-MM-dd HH:mm" v-model="value1" type="datetimerange"
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                  </div>
                </template>
              </div>
              <div class="flex-lm">
                <div class="font-size12 gray-font" style="margin-right: 10px;">排序选择</div>
                <template>
                  <el-select v-model="modelvalue" placeholder="请选择" @change="selectorder($event)" style="width: 150px;">
                    <el-option size="medium" v-for="item in options" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </div>
            </div>
          </div>

        </div>
        <div style="position: relative" v-if="tableloaded">
          <el-table border v-if="draftinfo.activityAuth" :data="tableData" ref="multipleTable" key="table333"
            :row-class-name="tableRowClassName" stripe @select-all="handleTableSelect" @select="handleTableSelect"
            :reserve-selection="false" header-row-class-name="header-row-class-name" style="width: 100%"
            @filter-change="filterTable" :height="(tableHeight - searchBlockHeight)">
            <el-table-column type="selection" align="center" width="55">
            </el-table-column>
            <el-table-column fixed align="center" prop="serialNumber" label="编号" width="60">
            </el-table-column>
            <el-table-column label="投稿内容" align="center" width="80">
              <template slot-scope="scope">
                <div @click="showProview(scope.row)">
                  <el-row type="flex" class="row-bg" justify="center" style="cursor: pointer">
                    <minCard :submission="scope.row"></minCard>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="大小" width="60">
              <template slot-scope="scope">
                {{ MG(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column label="投稿类型" align="center" width="80">
              <template slot-scope="scope">
                {{ (scope.row.materialList && scope.row.materialList.length > 0 &&
                  scope.row.materialList[0].exif) ? materialTypes[scope.row.materialList[0].exif.type] : '' }}
              </template>
            </el-table-column>
            <el-table-column v-if="draftinfo.activityAuth && draftinfo.activityAuth.isTrack == 1" prop="trackName"
              :filters="tableFilters.trackList" column-key="trackId" :filter-multiple="false"
              filter-placement="bottom-start" :filtered-value="tableFilterValues.trackId" minWidth="80" maxWidth="150">
              <template slot="header" slot-scope="scope">
                <el-popover placement="top-start" width="300" trigger="hover" style="width: 79%;float: left;">
                  <span class="font-more-two" slot="reference">{{ draftinfo.activityAuth.trackName || '组别/赛道' }}</span>
                  <span>{{ draftinfo.activityAuth.trackName || '组别/赛道' }}</span>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <trackCard :submission="scope.row" :draftinfo="draftinfo"></trackCard>
              </template>
            </el-table-column>
            <el-table-column v-if="draftinfo.activityAuth && draftinfo.activityAuth.isTag == 1" prop="unit"
              :filters="tableFilters.tagList" column-key="tagId" :filter-multiple="false"
              filter-placement="bottom-start" :filtered-value="tableFilterValues.tagId"
              :label="draftinfo.activityAuth.tagName || '投稿单元'" width="80">
              <template slot="header" slot-scope="scope">
                <el-popover placement="top-start" width="300" trigger="hover" style="width: 79%;float: left;">
                  <div class="font-more-two" slot="reference">{{ draftinfo.activityAuth.tagName || '投稿单元' }}</div>
                  <div>{{ draftinfo.activityAuth.tagName || '投稿单元' }}</div>
                </el-popover>
              </template>
              <template slot-scope="scope">{{ scope.row.unit }}</template>
            </el-table-column>
            <el-table-column prop="wardingName" label="所属相册" width="80">
              <template slot-scope="scope">
                {{ scope.row.wardingName || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="name"
              v-if="draftinfo.activityAuth.isSubmissionTips == 1 && draftinfo.activityAuth.isSubmissionName == 1"
              label="作品名称" minWidth="80">
              <template slot-scope="scope">
                <el-popover placement="top-start" title="" width="200" trigger="hover" :content="scope.row.name">
                  <div class="font-more-three" slot="reference">{{ scope.row.name }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="desc"
              v-if="draftinfo.activityAuth.isSubmissionTips == 1 && draftinfo.open_workdesc == 1" label="作品简介">
              <template slot-scope="scope">
                <el-popover placement="top-start" title="" width="200" trigger="hover" :content="scope.row.desc">
                  <div class="font-more-three" slot="reference">{{ scope.row.desc }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="materialList[0].content" v-if="hasOpenWord" min-width="160" label="文字内容">
              <template slot-scope="scope">
                <el-popover placement="top-start" title="" width="200" trigger="hover"
                  :content="scope.row.materialList[0].content">
                  <div class="font-more-three" slot="reference">{{ scope.row.materialList[0].content }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="likenum" align="center" label="点赞数" width="60">
              <template slot-scope="scope">{{ scope.row.likenum }}</template>
            </el-table-column>
            <el-table-column prop="gainVotes" align="center" label="投票数" width="60"
              v-if="draftinfo.activityAuth.isPopularVote == 1">
              <template slot-scope="scope">
                <router-link :to="'/home/votes?submissionId=' + scope.row.submissionId">
                  <el-button type="text">{{ scope.row.gainVotes }}</el-button>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="commentCount" align="center" label="评论数" width="60">
              <template slot-scope="scope">{{ scope.row.commentCount }}</template>
            </el-table-column>
            <el-table-column prop="imgCount" align="center" label="作品数" width="60">
              <template slot-scope="scope">{{ scope.row.imgCount }}</template>
            </el-table-column>
            <el-table-column prop="sign"
              v-if="draftinfo.activityAuth.isSubmissionTips == 1 && draftinfo.open_worksign == 1" label="作者署名"
              minWidth="80">
              <template slot-scope="scope">
                <el-popover placement="top-start" title="" width="200" trigger="hover" :content="scope.row.sign">
                  <div class="font-more-three" slot="reference">{{ scope.row.sign }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="用户名" minWidth="80">
              <template slot-scope="scope">{{ scope.row.username }}</template>
            </el-table-column>
            <el-table-column prop="mobile" v-if="draftinfo.activityAuth.isPresetName == 1" label="预设名单" width="80">
              <template slot-scope="scope">
                {{ scope.row.presetName || '' }}
              </template>
            </el-table-column>
            <template v-if="draftinfo.activityAuth.isContact == 1">
              <el-table-column prop="mobile" v-if="draftinfo.open_phone == 1" label="手机" width="80">
                <template slot-scope="scope">
                  {{ scope.row.mobile || '' }}
                </template>
              </el-table-column>
              <el-table-column prop="email" v-if="draftinfo.open_mail == 1" label="邮箱" width="80">
                <template slot-scope="scope">
                  {{ scope.row.email || '' }}
                </template>
              </el-table-column>
              <el-table-column prop="wechat" v-if="draftinfo.open_wechat == 1" label="微信号" width="80">
                <template slot-scope="scope">
                  {{ scope.row.wechat || '' }}
                </template>
              </el-table-column>
              <el-table-column prop="qq" v-if="draftinfo.open_qq == 1" label="QQ号" width="80">
                <template slot-scope="scope">
                  {{ scope.row.qq || '' }}
                </template>
              </el-table-column>
            </template>
            <template v-if="draftinfo.customFormInfo && draftinfo.customFormInfo.isEnable == 1">
              <template v-for="(item, index) in draftinfo.customFormInfo.inputList" v-if="item.status == 1">
                <el-table-column v-if="item.inputType == 3" :label="item.name"
                  :filters="tableFilters['custom_' + item.id]" :filtered-value="tableFilterValues['custom_' + item.id]"
                  :column-key="'custom_' + item.id" :filter-multiple="true" filter-placement="bottom-start" width="80">
                  <template slot="header" slot-scope="scope">
                    <el-popover placement="top-start" width="300" trigger="hover" style="width: 79%;float: left;">
                      <div class="font-more-two" slot="reference">{{ item.name }}</div>
                      <div>{{ item.name }}</div>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <template v-if="scope.row.customValues && scope.row.customValues.length > 0">
                      <template v-for="(input) in scope.row.customValues">
                        <el-popover v-if="item.id == input.inputId" placement="top-start" title="" width="200"
                          trigger="hover" :content="input.val">
                          <div class="font-more-three" slot="reference">{{ input.val }}</div>
                        </el-popover>
                      </template>
                    </template>
                    <template v-else="">
                      <template v-for="(item, index) in draftinfo.customFormInfo.inputList">
                        <p></p>
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column :label="item.name" width="80" v-else="">
                  <template slot="header" slot-scope="scope">
                    <el-popover placement="top-start" width="300" trigger="hover">
                      <div class="font-more-two" slot="reference">{{ item.name }}</div>
                      <div>{{ item.name }}</div>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <template v-if="scope.row.customValues && scope.row.customValues.length > 0">
                      <template v-for="(input) in scope.row.customValues">
                        <el-popover v-if="item.id == input.inputId" placement="top-start" title="" width="200"
                          trigger="hover" :content="input.val">
                          <div class="font-more-three" slot="reference">{{ input.val }}</div>
                        </el-popover>
                      </template>
                    </template>
                    <template v-else="">
                      <template v-for="(item, index) in draftinfo.customFormInfo.inputList">
                        <p></p>
                      </template>
                    </template>
                  </template>
                </el-table-column>
              </template>
            </template>
            <el-table-column prop="date" label="投稿时间" minWidth="100">
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="60">
              <template slot-scope="scope">
                <el-dropdown @command="deleteSub">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ scope: scope, act: 'sea' }">查看</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope, act: 'votes' }"
                      v-if="draftinfo.activityAuth.isPopularVote == 1">审核投票</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope, act: 'del' }">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <div class="reports-page" ref="page">
            <el-pagination background layout="total,sizes,prev, pager, next" :total="total"
              @size-change="handleSizeChange" :page-sizes="[20, 50, 100]" :page-size="pageSize"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
          <div class="text-xs text-gray" style="position: absolute;top:-1px;left:4px;z-index: 99;">全选本页</div>
        </div>
      </div>

    </div>
    <!-- <div class="flex-vc" :style="{minHeight:minHeight+'px'}">
      <img src="https://assets.pfotoo.com/pc/img/nodiving.svg"/>
      <div class="gray-font font-size14" style="padding: 10px 0px 20px;">暂无征稿</div>
      <a class="green-font font-size14 flex-cm" style="widdiv: 130px; height: 30px; border-radius: 15px; border: 1px solid rgb(61, 196, 167); cursor: pointer;" href="https://support.qq.com/product/57964" target="_blank">去提需求</a>
    </div> -->
    <div class="pdf-mask" :hidden="pdfhidden" @click="closepdf"></div>
    <div class="fixed left right top botton pdf-cover bg-white" :hidden="pdfhidden">
      <pdf v-for="i in numPages" :key="i" :src="pdfurl" :page="i">
      </pdf>
    </div>
    <dialogDown ref="dialogDown" :draftinfo="draftinfo" :residueSize="draftinfo.residualDownloadTraffic / 1"
      v-on:down="download"></dialogDown>
    <dialogDownAll ref="dialogDownAll" :draftinfo="draftinfo" :residueSize="draftinfo.residualDownloadTraffic / 1">
    </dialogDownAll>
    <proview ref="proview" :draftinfo="draftinfo" :identityType="identityType"
      v-if="draftinfo.activityAuth && tableloaded">
    </proview>
  </div>
</template>

<script>
import headerCom from '../header.vue'
import pdf from 'vue-pdf'
import draftcover from '../draftcover.vue'
import tab from '../tab.vue'
import App from '../../util/comfun'
import JSZip from 'JSZip'
import minCard from '../card/min.vue'
import trackCard from '../card/track.vue'
import dialogDown from '../dialog/down.vue'
import dialogDownAll from '../dialog/downAll.vue'
import proview from '../dialog/proview.vue'
import ElLink from "../../../node_modules/element-ui/packages/link/src/main.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import election from "../election/index.vue"
import optionPlane from "../dialog/option-plane.vue"
import trafficPopover from '../card/traffic-popover.vue'
const limitRows = 1000;//单次请求最大条数
import ElIcon from "../../../node_modules/element-ui/packages/icon/src/icon.vue";

export default {
  name: 'reports',
  data() {
    return {
      minHeight: window.innerHeight - 82,
      tableHeight: window.innerHeight - 230,
      tableData: [],
      draftlist: [],
      id: '',
      draftinfo: {},
      allselect: false,
      workidstr: '',
      workidarr: [],
      workidsize: 0,//已勾选sum大小
      selectedAllSize: 0,//全部投稿大小
      imgidstr: '',
      imgidarr: [],
      offset: 20,
      minwidth: window.innerWidth - 285,
      openid: JSON.parse(localStorage.getItem('userinfo')).openid,
      pdfurl: '',
      numPages: 1,
      page: 1,
      pageSize: 50,
      pdfhidden: true,
      total: 0,
      unitlist: [],
      unit: '',
      options: [
        {
          label: '按投稿顺序排序',
          value: 1
        },
        {
          label: '按点赞量排序',
          value: 2
        },
        {
          label: '按投票数量排序',
          value: 3
        }
      ],
      timeoption: [
        {
          label: '全部时间',
          value: 1
        },
        {
          label: '最近7天',
          value: 7
        },
        {
          label: '最近30天',
          value: 30
        },
        {
          label: '自定义',
          value: 100
        }
      ],
      modelvalue: 1,
      modeltime: 1,
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      alllist: [],
      searchval: '',
      inputfocus: false,
      total: 0,
      obj: {
        type: 'new'
      },
      imgCount: 0,
      worksCount: 0,
      browse: 0,
      likenum: 0,
      commentCount: 0,
      activeMaterialType: '',
      materialTypes: {
        1: '照片',
        2: '视频',
        5: '音频',
        3: '文字',
        4: '文档',
        Picture: '照片',
        Video: '视频',
        Audio: '音频',
        Word: '文字',
        Document: '文档',
      },
      activeTrackId: '',
      hasOpenWord: false,
      statistics: null,
      searchBlockHeight: 10,
      hasSselectedAll: false,//全局全选
      pageRows: 0,//当前页面真实条数
      hasSelectedTip: true,
      identityType: -1,//identityType 0创建，1管理，2协作
      VERSIONS: {},
      tableloaded: false,
      tableFilters: {},//表格筛选项
      tableFilterValues: {
        tagId: ["1405282702948633998"],
      },//表格筛选项-值
    }
  },
  components: {
    ElIcon,
    ElButton,
    ElLink,
    headerCom,
    pdf,
    draftcover,
    tab,
    minCard,
    dialogDown,
    proview,
    dialogDownAll,
    election,
    optionPlane,
    trackCard,
    trafficPopover,
  },
  methods: {
    MG: App.MG,
    isDownAllButton() {
      if (App.hasTest() && this.draftinfo.activityId >= 8616) return true
      if (this.draftinfo.activityId >= 8732) return true
      return false
    },
    tableRowClassName({ row, index }) {
      //console.log('tableRowClassName',row)
      if (this.workidarr && this.workidarr.length > 0) {
        if (this.workidarr.includes(row.id)) {
          return 'selected'
        }
      }
      return '';
    },
    changefoucusval() {
      this.inputfocus = !this.inputfocus;
      console.log('ttttt', this.inputfocus);
      if (!this.inputfocus && this.searchval == '') {
        this.obj.type = 'new';
        this.page = 1;
        this.getnewlist();
      }
    },
    search() {
      this.workidstr = '';
      this.workidarr = [];
      this.imgidstr = '';
      this.imgidarr = [];
      if (this.searchval == '') {
        this.obj.type = 'new';
        this.page = 1;
      } else {
        this.obj.type = 'search';
        this.page = 1;
      }
      this.getnewlist();
    },
    lookannex(url, suffix) {
      if (suffix != 'pdf' && suffix != 'PDF') {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url)
      } else {
        this.pdfurl = url;
        this.pdfhidden = false;
        this.getNumPages(url);
      }

    },
    selectorder(val) {
      console.log('selectorder', val)
      this.modelvalue = val;
      this.page = 1;
      this.total = 0;
      this.selectorderObj = { type: val }
      this.getnewlist();
      /*
      if(val==2){
        this.groupid=0;
        this.obj={
          groupid:0,
          type:'like',
        }
        this.page=1;
        this.workidarr=[];
        this.workidstr='';
        this.imgidarr=[];
        this.imgidstr='';
        this.allselect=false;
        this.getworklist();
      }
      */
    },
    selecttime(val) {
      console.log('selecttime', val);
      if (val == 100) {
        this.getvalue();
      }
      this.modeltime = val;
      this.page = 1;
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.allselect = false;
      this.total = 0
      this.getnewlist();
    },
    selectdate(val) {
      console.log(val)
      this.value1 = val;
      this.page = 1;
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.allselect = false;
      this.total = 0
      this.getnewlist();
    },
    getNumPages(url) {
      var loadingTask = pdf.createLoadingTask(url);
      console.log(loadingTask)
      loadingTask.promise.then(pdf => {
        console.log('rccc', pdf, pdf.numPages)
        this.numPages = pdf.numPages
      }).catch((err) => {
        console.error('pdf加载失败')
      })
    },
    closepdf() {
      this.pdfhidden = true;
    },
    getsign() {
      return this.$getsign();
    },
    changedate(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var w = date.getDay();
      return { year: Y, month: M, day: D, hour: h, minute: m, second: s, week: w };
    },
    getvalue() {
      let sdate = new Date(Date.parse(new Date()) - 30 * 24 * 60 * 60 * 1000);
      this.value1 = [sdate, new Date()];
    },
    getdetail() {
      this.tableloaded = false
      //this.inputkeys = {}
      this.queryUserIdentityType()
      App.Contribution.GetContributionById({ id: this.id }).then(json => {
        if (json.code == 200) {
          json.data.removead = json.data.activityAuth.isAdvertisement
          json.data.id = json.data.activityId
          json.data.name = json.data.activityName
          json.data.introduce = json.data.description
          json.data.images = json.data.activityCovers[0].url
          json.data.long_term = json.data.isLongTerm
          json.data.ispublic = json.data.visibleType//投稿可见类型 0：都可见 1：仅组织者可见
          json.data.iscomment = json.data.isComment//投稿作品评论（是否支持评论 1 是 0 否）
          json.data.type = App.metaKey(json.data.activityType, App.metaTypeHD)
          //附件
          json.data.is_enclosure = json.data.activityAuth.isAnnex
          json.data.enclosure_desc = json.data.activityAuth.enclosureTips
          //作品信息
          json.data.open_worksign = json.data.activityAuth.isAuthorName
          json.data.open_workdesc = json.data.activityAuth.isSubmissionDesp
          json.data.open_workname = json.data.activityAuth.isSubmissionName
          json.data.text = json.data.activityAuth.submissionTips
          //联系方式
          json.data.contacts_text = json.data.activityAuth.contactTips
          json.data.open_mail = json.data.activityAuth.isEmail
          json.data.open_phone = json.data.activityAuth.isMobile
          json.data.open_qq = json.data.activityAuth.isQq || 0
          json.data.open_wechat = json.data.activityAuth.isWechat

          json.data.status = json.data.activityStatus == 1 ? 0 : 1
          //投稿要求
          json.data.other = json.data.activityAuth.submissionRequire || ''
          //theme!='不限题材
          json.data.theme = '不限题材'
          if (json.data.tagList.length > 0) {
            let theme = [];
            json.data.tagList.forEach(t => {
              theme.push(t.name)
            })
            json.data.theme = theme.join(',')
          }
          //time
          json.data.stime = json.data.startTime
          json.data.etime = json.data.endTime
          json.data.close_time = json.data.deadlinesTime || ''

          json.data.residualDownloadTraffic = 0
          this.draftinfo = json.data
          this.getTrafficUser()
          //this.total=json.data.worksCount
          if (json.data.theme != '不限题材') {
            let arr = json.data.theme.split(',');
            let themelist = [];
            for (let i = 0; i < arr.length; i++) {
              themelist.push({
                name: arr[i],
                isactive: false,
              })
            }
            this.unitlist = themelist;
          } else {
            this.unitlist = [];
          }

          //
          this.hasOpenWord = json.data.activityType == 'Word'
          if (json.data.activityType == "Mixin") {
            json.data.activityMaterialTypeRefs.some(rule => {
              if (rule.activityMaterialType == 'Word' && rule.enable == 1) {
                this.hasOpenWord = true
              }
            })
          }
          //
          App.demand('/activity/activityCount/' + json.data.activityId, 'GET').then(res => {
            this.statistics = res.data
          })
          this.VERSIONS = wxlite.VERSIONS
          ////format unit ....
          //this.inputkeys = {}
          this.initTableFilters()
          setTimeout(() => {
            this.$nextTick(() => {
              this.tableloaded = true
              if (this.$refs.multipleTable) {
                console.error('getdetail', this.$refs.multipleTable)
                this.$refs.multipleTable.clearSort()
                this.$refs.multipleTable.clearFilter()
                this.$refs.multipleTable.doLayout()
              }
              this.getnewlist();
            })
          }, 300)
        }
      })
    },
    initTableFilters() {
      let tagList = [], trackList = []
      if (this.draftinfo.tagList && this.draftinfo.tagList.length > 0) {
        this.draftinfo.tagList.forEach(t => {
          tagList.push({ text: t.name, value: t.id })
        })
      }
      if (this.draftinfo.trackList && this.draftinfo.trackList.length > 0) {
        this.draftinfo.trackList.forEach(t => {
          if (t.childList && t.childList.length > 0) {
            t.childList.forEach(ct => {
              trackList.push({ text: t.name + '→' + ct.name, value: ct.id })
            })
          } else {
            trackList.push({ text: t.name, value: t.id })
          }
        })
      }
      this.tableFilters['tagList'] = tagList
      this.tableFilters['trackList'] = trackList
      this.tableFilterValues['tagId'] = []
      this.tableFilterValues['trackId'] = []
      if (this.draftinfo.customFormInfo && this.draftinfo.customFormInfo.inputList && this.draftinfo.customFormInfo.inputList.length > 0) {
        this.draftinfo.customFormInfo.inputList.forEach(input => {
          if (input.inputType == 3 && input.selectList && input.selectList.length > 0) {
            let opts = []
            input.selectList.forEach(opt => {
              opts.push({ text: opt.label, value: opt.label })
            })
            this.tableFilters['custom_' + input.id] = opts
            this.tableFilterValues['custom_' + input.id] = []
          }

        })
      }
    },
    getTrafficUser() {
      App.demand('/user/info', 'GET', {
        userId: this.draftinfo.createBy,
      }).then(res => {
        this.draftinfo.residualDownloadTraffic = res.data.residualDownloadTraffic / 1
        this.draftinfo.resetRightsDay = res.data.resetRightsDay
      })
    },
    handleTableSelect(selected) {
      this.hasSelectedTip = true
      //console.error('handleTableSelect',selected)
      this.selected = selected
      let workidarr = [];
      let workidsize = 0
      selected.forEach((v, i) => {
        if (v.id) {
          workidarr.push(v.id);
          workidsize += v.size / 1
        }
      })
      this.workidsize = workidsize
      this.workidarr = workidarr;
      this.workidstr = workidarr.toString();
      if (this.hasSselectedAll) {
        this.hasSselectedAll = this.workidarr.length == this.pageRows
      }
      //this.currentRow = val;
    },
    fileNamePass(fileName) {
      //“喜迎二十大 建功新时代”_南网数字集团职工及职工家庭文创作品征集活动 (2)
      return fileName.replace(/[\\\/:\*\?"'<>_\| ]/g, '');
    },
    getDownTotal() {
      let total = 0, size = 0
      //console.error('getDownTotal',this.selected)
      if (this.selected && this.selected.length > 0) {
        this.selected.forEach(sub => {
          total += 1
          if (sub.materialList) {
            sub.materialList.forEach(file => {
              size += file.size / 1
              //total+=1
            })
          }
          if (sub.enclosureList) {
            sub.enclosureList.forEach(file => {
              size += file.size / 1
              //total+=1
            })
          }
        })
      }
      return { total, size }
    },
    downAllDialog(hasAll = '') {
      if (![0, 1].includes(this.identityType)) {
        return this.$message({
          showClose: true,
          message: App.identityTypes(this.identityType) + '无操作权限',
          type: 'error',
        });
      }
      let hasSselectedAll = this.hasSselectedAll
      if (hasAll == 'all') {
        hasSselectedAll = true
      } else {
        if (!this.workidarr || this.workidarr.length == 0) {
          this.selected = []
          this.$message({
            showClose: true,
            message: '请选择投稿'
          });
          return
        }
      }


      this.$refs.dialogDownAll.show({
        params: {
          ...this.params,
          isGlobal: hasSselectedAll ? 1 : 0,
          submissionIdList: hasSselectedAll ? [] : this.workidarr,
        },
        total: hasSselectedAll ? this.total : this.workidarr.length
      })
    },
    downDialog() {
      if (this.hasSselectedAll && this.total > this.pageSize) {
        return this.$alert('批量下载仅支持选择本页内容', '请重新选择后再试', {
          confirmButtonText: '知道了',
          type: 'warning',
          confirmButtonClass: 'confirmButtonClass',
          customClass: 'customClass',
        })
      }
      if (![0, 1].includes(this.identityType)) {
        return this.$message({
          showClose: true,
          message: App.identityTypes(this.identityType) + '无操作权限',
          type: 'error',
        });
      }
      if (!this.workidarr || this.workidarr.length == 0) {
        this.selected = []
        this.$message({
          showClose: true,
          message: '请选择投稿'
        });
        return
      }

      this.downTotal = this.getDownTotal()
      console.log('downTotal', this.downTotal)
      this.$refs.dialogDown.show(this.downTotal)
    },
    download(e) {
      console.log('download', e)
      this.downOverNum = 0
      let loading = this.$loading({
        lock: true,
        text: "正在下载 " + this.downOverNum + '/' + this.downTotal.total,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: 'custom-loading'
      });
      let downs = []
      var zip = new JSZip();
      var zippack = zip.folder(this.draftinfo.activityName);
      let files = {}
      this.tableData.some(row => {
        if (this.workidarr.includes(row.id)) {
          this.workidarr = this.workidarr.filter((xid) => { return xid != row.id })
          console.log('download-row', row)
          let pathName = (row.autograph || row.username) + '-' + row.serialNumber
          row.materialList.forEach((file, findex) => {
            if (!file.exif.suffix) return false
            let url = file.url.replace('http://', 'https://')
            if (e.type == 'compress') {//使用压缩图
              if (file.size && file.size < 20 * 1024 * 1024) {
                if (/(\.jpg)|(\.jpeg)|(\.png)|(\.bmp)|(\.gif)/g.test(file.materialName)) {
                  url += '?imageMogr2/thumbnail/1220x/quality/100!/ignore-error/1'//缩略图
                }
              }
            }
            //url+=(url.indexOf('?')==-1?'?':'&')+'_t='+Math.random()
            //let down=App.download(url,file.materialName.replace('null',(row.autograph||row.nickName)))
            let fname = [row.submissionName || row.username, row.serialNumber]
            if (row.materialList.length > 1) {
              fname.push('(' + (findex / 1 + 1) + ')')
            }
            fname = fname.join('-') + '.' + file.exif.suffix
            let fileName = this.fileNamePass(pathName) + '/'
              //+this.fileNamePass(file.materialName.replace('null',(pathName)))
              + this.fileNamePass(fname)
            if (!files[fileName]) {
              files[fileName] = []
            }
            files[fileName].push(url)
          })
          if (row.enclosureList && row.enclosureList.length > 0) {
            row.enclosureList.forEach((file, index) => {
              let url = file.url
              if (e.type == 'compress') {//使用压缩图
                if (file.size && file.size < 20 * 1024 * 1024) {
                  if (/(\.jpg)|(\.jpeg)|(\.png)|(\.bmp)|(\.gif)/g.test(file.name)) {
                    url += '?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1'//缩略图
                  }
                }
              }
              //url+=(url.indexOf('?')==-1?'?':'&')+'_t='+Math.random()
              //let down=App.download(url,file.materialName.replace('null',(row.autograph||row.nickName)))
              let fileName = this.fileNamePass(pathName) + '/附件/' + this.fileNamePass(file.name.replace('null', (pathName)))
              if (!files[fileName]) {
                files[fileName] = []
              }
              files[fileName].push(url)
            })
          }
          if (this.workidarr.length == 0) return true;
        }
      })
      //console.error('files',files,Object.keys(files).length)
      Object.keys(files).forEach(fileName => {
        files[fileName].forEach((url, index) => {
          let fileNameExt = fileName
          /*if(files[fileName].length>1){
            fileNameExt=fileName.replace(/\.[^\.]+$/g,function(ext){return ' ('+(index+1)+')'+ext})
          }*/
          console.log(fileNameExt, url)
          let down = App.downloadZip(url, fileNameExt, zippack).then(res => {
            console.log('App.downloadZip', fileNameExt)
            this.downOverNum++
            //this.loadingInstance.setText("正在下载 "+this.downOverNum+'/'+this.downTotal.total);
            document.querySelector(".el-loading-text").innerHTML = "正在下载 " + this.downOverNum + '/' + downs.length
          }).catch(res => { console.error(res) })
          downs.push(down)
        })
      })
      //console.error('downs',downs,downs.length)
      //console.log('Promise.downs',loading)
      Promise.all(downs).then(res => {
        //console.log('Promise.all',res)
        this.$refs.multipleTable.clearSelection();
        this.selected = []
        document.querySelector(".el-loading-text").innerHTML = "下载完成，正在打包..."
        zip.generateAsync({ type: "blob" }).then((content) => {
          // content就是blob数据，这里以example.zip名称下载
          //let blob = new Blob([data]);
          let aurl = window.URL.createObjectURL(content)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = aurl
          link.setAttribute('download', this.draftinfo.activityName + ".zip")
          document.querySelector(".el-loading-text").innerHTML = "打包完成!"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          App.demand('/download/record/save', 'POST', {
            "activityId": this.draftinfo.activityId,
            "downloadTerminal": 1,
            "downloadType": 1,
            "fileName": this.draftinfo.activityName + ".zip",
            "fileSize": content.size > this.downTotal.size ? this.downTotal.size : content.size,
            "status": 2
          }).then(() => { this.getdetail(); })
          setTimeout(() => { loading.close(); }, 800)
        });
      }).catch(res => {
        setTimeout(() => { loading.close(); }, 800)
      })
    },
    async downexcelAll() {//下载全部
      if (this.total < limitRows) return this.downexcel(true)
      let pageCount = Math.ceil(this.total / limitRows)
      this.downOverNum = 1
      let loading = this.$loading({
        lock: true,
        text: "正在下载 " + this.downOverNum + '/' + pageCount,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: 'custom-loading'
      });
      let params = JSON.parse(JSON.stringify(this.params))
      let fn = this.draftinfo.activityName.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '')
      var zip = new JSZip();
      var zippack = zip.folder((fn || this.draftinfo.activityId) + '.xlsx');
      //return await this.merge_file_appx(zippack)

      for (; this.downOverNum <= pageCount;) {
        params.pageIndex = this.downOverNum
        params.pageSize = limitRows
        let resData = await App.Submission.Export(params)
        let filename = `part.${this.downOverNum}.xlsx`
        zippack.file(filename, resData)
        document.querySelector(".el-loading-text").innerHTML = "正在下载 " + (this.downOverNum++) + '/' + pageCount
      }
      let qv = '?' + Math.random()
      let merge_py = await App.download('https://www.pfotoo.com/static/bin/merge_excel.py' + qv, '', true)
      zippack.file('merge_excel.py', merge_py)
      /*** 判断windows系统 ***/
      window.isWindows = /windows|win32/i.test(navigator.userAgent);
      if (window.isWindows) {
        let merge_do = await App.download('https://www.pfotoo.com/static/bin/合并文件.bat' + qv, '', true)
        zippack.file('合并文件.bat', merge_do)
      } else {
        let merge_sh = await App.download('https://www.pfotoo.com/static/bin/merge_excel.sh' + qv, '', true)
        zippack.file('merge_excel.sh', merge_sh)
      }
      //await this.merge_file_appx(zippack)

      document.querySelector(".el-loading-text").innerHTML = "下载完成，正在打包..."
      zip.generateAsync({ type: "blob" }).then((content) => {
        let aurl = window.URL.createObjectURL(content)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = aurl
        link.setAttribute('download', (fn || this.draftinfo.activityId) + ".xlsx.zip")
        document.querySelector(".el-loading-text").innerHTML = "打包完成!"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => { loading.close(); }, 800)
      })
    },
    getZipFD(f) {
      return new Promise((resolve) => {
        f.async('base64').then(content => {
          //zippack.file(filename, content)
          console.log(content)
          resolve(content)

        })
      })
    },
    async merge_file_appx(zippack) {
      let pack = await App.download('https://www.pfotoo.com/static/bin/%E5%90%88%E5%B9%B6%E6%96%87%E4%BB%B6.zip?2', '', true)
      zippack.file('合并文件.zip', pack)
      return;
      const zipData = await JSZip.loadAsync(pack);
      let files = zipData.files
      //zippack.file(zipData.files)
      for (const filename of Object.keys(files)) {
        if (filename.indexOf('__MACOSX') > -1) continue; // 忽略Mac系统生成的隐藏文件夹
        console.log('filename', filename, files[filename])
        zippack.file(filename, await this.getZipFD(files[filename]), {
          unixPermissions: "755",
          //dosPermissions: 755,
          base64: true,
          binary: true,
        })

      }
    },

    async downexcel(hasAll = false) {
      if (!hasAll && this.workidarr.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择投稿'
        });
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '数据准备中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = JSON.parse(JSON.stringify(this.params))
      params.pageIndex = 1
      params.pageSize = limitRows
      if (!hasAll) {
        if (this.workidarr.length > 0) {
          params.submissionIdList = this.workidarr
        }
      }
      App.Submission.Export(params).then(data => {
        loading.close();
        //let blob = new Blob([data], {type: "application/vnd.ms-excel"});
        let blob = new Blob([data], { type: "application/vnd.ms-excel" })
        //let blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        let fn = this.draftinfo.activityName.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '')
        link.setAttribute('download', (fn || this.draftinfo.activityId) + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      // this.exportData();
    },
    hidedraft() {
      this.$refs.collectcover.closedraft();
    },
    handleCurrentChange(val) {
      console.log(val)
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = val;
      this.allselect = false;
      this.getnewlist();
      this.allselect = false;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleCurrentChange(this.page)
    },
    getdraftid(obj) {
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;

      this.id = obj.id;
      this.params = {
        activityId: this.id,
        pageIndex: this.page,
        pageSize: this.pageSize,
        orderOption: '',
      }
      this.hidedraft();
      this.getdetail();

      //this.refs.optionPlane.initParams()
    },
    tellgroup(obj) {
      console.log('tellgroup', obj);
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;
      this.tellgroupObj = obj
      if (obj.groupid != 0) {
        this.groupid = obj.groupid;
        this.getnewlist();
        //this.getgrouplist(obj.groupid);
        //this.total=obj.total;
      } else {
        this.groupid = obj.groupid;
        this.getnewlist();
        /*
        if(obj.type=='hot'){
          this.gethotlist();
        }else{
          this.getnewlist();
        }
        */
        this.obj = obj;
        this.allselect = false;
        //this.total=this.draftinfo.wCount;
      }
    },
    //获得tagId
    getTagId(params) {
      console.info('getTagId', this.unit, this.draftinfo)
      if (this.unit && this.draftinfo.tagList) {
        this.draftinfo.tagList.some(t => {
          if (t.name == this.unit) {
            params.tagId = t.id
            return true
          }
        })
      }
      return params
    },
    getnewlist() {
      let loading = this.$loading({ text: 'loading...', target: '.down-content', })
      this.params.pageIndex = this.page
      this.params.pageSize = this.pageSize
      this.params.keyword = ''
      if (this.searchval) {
        this.params.keyword = this.searchval
      }
      /*
      console.log('this.inputkeys', this.inputkeys)
      let inputkeys = Object.keys(this.inputkeys||{})
      if (inputkeys.length > 0) {
        let queryInputList = []
        inputkeys.forEach((key, i) => {
          if(key.indexOf('custom_')>-1){
            //自定义表单
            let inputId=key.replace('custom_','')
            if(this.inputkeys[key].length>0){
              queryInputList.push({
                queryInputId:inputId,
                queryValueList:this.inputkeys[key]
              })
            }
          }else{
            //固定表单
            this.params[key] = this.inputkeys[key]
          }
          
        })
        
        this.params.queryInputList=queryInputList
        
      }
      */
      this.hasSelectedTip = true
      window.SubmissionParams = this.params
      App.Submission.List(this.params).then(json => {
        setTimeout(() => { loading.close(); }, 0)
        this.tableloaded = true
        if (json.code == 200) {
          //this.imgCount=json.data.materialCount
          this.imgCount = json.data.total
          this.worksCount = json.data.contributorCount
          this.browse = json.data.viewCount
          this.likenum = json.data.likeCount
          this.commentCount = json.data.commentCount
          json.data.submissionInfoList = json.data.submissionInfoList || []
          this.pageRows = json.data.submissionInfoList.length
          if (this.pageRows > 0) {
            json.data.submissionInfoList.forEach((v, i) => {
              v.id = v.submissionId
              v.cdate = parseInt(new Date() / 1000)
              //v.images=v.submissionMaterialList
              v.sign = v.autograph
              v.imgCount = v.materialCount
              v.likenum = v.likeCount
              v.desc = v.description
              v.nickname = v.nickName
              v.name = v.submissionName
              v.unit = v.tagName
              //v.gname=v.wardingName
              try {
                v.customize = JSON.parse(v.customize)
                v.mobile = v.customize.mobile
                v.qq = v.customize.qq
                v.wechat = v.customize.wechat
                v.email = v.customize.email
              } catch (e) { }
              v.isselect = false;
              let dateobj = this.changedate(Number(v.cdate) * 1000), connect = '/';
              v.date = v.createTime
              v.size = 0
              v.materialList.forEach(vm => {
                v.size += vm.size / 1
                try { vm.exif = JSON.parse(vm.exif) } catch (e) { }
                try { vm.coverInfo = JSON.parse(vm.coverInfo) } catch (e) { }
                App.setPlayerUrl(vm)
              })
              v.enclosureList.forEach(vm => {
                v.size += vm.size / 1
              })
            })
          }
          let tableData = json.data.submissionInfoList || [];

          this.alllist = this.alllist.concat(tableData);

          this.tableData = tableData;
          this.total = json.data.total;
          console.log(this.tableData);
          //console.log('this.$refs.searchBlock.offsetHeight',this.$refs.searchBlock.offsetHeight)
          //this.searchBlockHeight=this.$refs.searchBlock.offsetHeight>10?this.$refs.searchBlock.offsetHeight:10
          this.searchBlockHeight = 10
          if (this.tableHeight == window.innerHeight) {//已滚动
            this.$refs.allTable.style.display = 'none'
            this.searchBlockHeight = 130
          }

          setTimeout(() => {
            this.$nextTick(() => {
              if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
                this.$refs.multipleTable.doLayout()
                if (this.hasSselectedAll) {
                  this.$refs.multipleTable.toggleAllSelection();
                }
              }

            })
          }, 300)
        } else {
          this.imgCount = 0
          this.worksCount = 0
          this.browse = 0
          this.likenum = 0
          this.commentCount = 0
          this.tableData = [];
          this.allselect = false;
          this.total = 0;
          this.$message({
            showClose: true,
            message: json.message
          });

        }
      })
    },
    selectunit(index) {
      this.total = 0
      this.unitlist.forEach((v, i) => {
        if (index == i) {
          v.isactive = !v.isactive;
          this.unitlist[index].isactive = v.isactive;
          this.unit = v.isactive ? v.name : '';
          this.workidarr = [];
          this.workidstr = '';
          this.imgidarr = [];
          this.imgidstr = '';
          this.page = 1;
          this.getnewlist();
        } else {
          v.isactive = false;
          this.unitlist[i].isactive = v.isactive;
        }
      })
    },
    selectMaterialType(MaterialType) {
      if (this.activeMaterialType == MaterialType) {
        this.activeMaterialType = ''
      } else {
        this.activeMaterialType = MaterialType
      }
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;
      this.getnewlist();
    },
    selectTrackId(TrackId) {
      if (this.activeTrackId == TrackId) {
        this.activeTrackId = ''
      } else {
        this.activeTrackId = TrackId
      }
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;
      this.getnewlist();
    },
    downall() {
      this.$router.push({
        path: '/pay'
      })
    },
    deleteSub(command) {
      console.log('deleteSub', command)
      let row = command.scope.row
      if (command.act == 'del') {
        if (![0, 1].includes(this.identityType)) {
          return this.$message({
            showClose: true,
            message: App.identityTypes(this.identityType) + '无操作权限',
            type: 'error',
          });
        }
        this.$confirm('此操作将永久删除该投稿, 是否继续?', '', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          cancelButtonClass: 'cancelButtonClass',
          confirmButtonClass: 'confirmButtonClass',
          customClass: 'customClass',
        }).then(() => {
          App.demand('/submission/delete', 'POST', {
            submissionIdList: [row.id],
          }).then(() => {
            this.getnewlist()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
        }).catch(() => { });
      } else if (command.act == 'sea') {
        this.$refs.proview.show(row)
      } else if (command.act == 'votes') {
        this.$router.push({
          path: '/home/votes?submissionId=' + row.submissionId
        })
      }
    },
    showProview(row) {
      console.log('showProview', row)
      this.$refs.proview.show(row)
    },
    optionPlaneEvent(e) {
      this.tableloaded = false

      console.log('optionPlaneEvent', e)
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;
      this.hasSselectedAll = false
      this.params = e.params
      this.selectedAllSize = 0
      this.initTableFilters()
      if (this.params.tagId) {
        this.tableFilterValues['tagId'] = [this.params.tagId]
      } 
      if (this.params.trackId) {
        this.tableFilterValues['trackId'] = [this.params.trackId]
      } 
      if (this.params.queryInputList && this.params.queryInputList.length > 0) {
        this.params.queryInputList.forEach(input => {
          this.tableFilterValues['custom_' + input.queryInputId] = input.queryValueList
          //this.$set(this.tableFilterValues,'custom_'+input.queryInputId,input.queryValueList)
        })
      }
      console.log('this.tableFilterValues', this.tableFilterValues)
      this.getnewlist()
    },
    switchSelectedAll() {
      this.selectedAllSize = 0
      this.hasSselectedAll = !this.hasSselectedAll
      if (this.hasSselectedAll) {
        if (this.$refs.multipleTable.data.length > this.$refs.multipleTable.selection.length) {
          this.$refs.multipleTable.toggleAllSelection();
        }
        this.queryTotalSize(this.params)
      } else {
        this.$refs.multipleTable.clearSelection();
        this.workidsize = 0
        this.workidarr = [];
      }
    },
    hideSelectedTip() {
      this.hasSelectedTip = false
    },
    async queryTotalSize(query) {
      let params = JSON.parse(JSON.stringify(query))
      if (params.materialType) {
        params.activityMaterialType = params.materialType
        delete params.materialType
      }
      params.wardingResultId = params.wardingId
      delete params.pageIndex
      delete params.orderOption
      delete params.pageSize
      params.isGlobal = this.hasSselectedAll ? 1 : 0
      params.submissionIdList = this.hasSselectedAll ? [] : this.workidarr,
        console.log('queryTotalSize', params)
      let res = await App.demand('/download/queryTotalSize', 'POST', params)
      this.selectedAllSize = res.data / 1
    },
    queryUserIdentityType() {
      if (!this.id) return
      App.demand('/activity/queryUserIdentity', 'GET', { activityId: this.id }).then(res => {
        this.identityType = res.data.identityType
      })
    },
    filterTable(filterValue) {
      console.log('filterTable', filterValue)
      let key = Object.keys(filterValue)[0]
      let inputValues;
      if (key.indexOf('custom_') > -1) {
        //自定义表单
        inputValues = filterValue[key]
      } else {
        //固定表单
        inputValues = filterValue[key][0]
      }
      console.log('filterTable.inputkeys', key, inputValues)
      return this.$refs.optionPlane.setTableFilterValues(key, inputValues)
      this.workidarr = [];
      this.workidstr = '';
      this.imgidarr = [];
      this.imgidstr = '';
      this.page = 1;
      this.total = 0
      this.allselect = false;
      this.getnewlist();

      return false
    },
  },
  mounted() {
    console.log('reports.mounted')
    this.getvalue();
  },
  activated() {
    console.log('reports.activated')
    //this.getvalue();
    this.getdetail()
  },

}
</script>

<style lang="scss">
.el-table-filter {
  .el-table-filter__list {
    max-height: 30vh;
    overflow-y: auto;
  }
}

.el-table th.el-table__cell>.cell {
  padding-left: 5px;
  padding-right: 5px;
}

.download {
  position: relative;
}

.down-content {
  width: 100%;
  position: relative;
  padding: 0;
}

.table-header {
  background: #FAFAFA;
}

.tr {
  height: 40px;
  line-height: 1.4;
  overflow: hidden;
}

.td {
  width: 60px;
  min-height: 40px;
  text-align: center;
  padding: 10px 5px;
  box-sizing: border-box;
  border-right: 1px solid #E0E0E0;
}

.bg-light-gray {
  background: #EEF2F2;
}

.table-total {
  width: 100%;
  height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
}

.draft-total-data>div {
  margin-left: 20px;
  color: #999;
}

.draft-total-data>div:first-child {
  margin-left: 10px;
}

.draft-total-data .font-size14 {
  color: #353535;
}

.down-content {
  width: 100%;
  padding-left: 15px;
  box-sizing: border-box;
}

/* .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  } */
.table {
  width: 100%;
  border-top: 1px solid #E0E0E0;
  box-sizing: border-box;
  min-height: 540px;
  border-collapse: collapse;
}

.td:first-child {
  border-left: 1px solid #E0E0E0;
}

.checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
}

.reports-page {
  padding: 10px 0;
}

.work-img {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.td a {}

.td a:hover {
  color: #27C4A2;
}

.pdf-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, .8);
}

.pdf-cover {
  width: 800px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 10000;
  overflow: scroll;
  box-sizing: border-box;
}

.detail-unit-list {
  padding-top: 18px;
}

.detail-unit-single {
  margin-right: 30px;
  margin-bottom: 10px;
  line-height: 20px;
  padding: 5px 0;
  cursor: pointer;
  font-weight: 500;
}

.unit-green-font {
  border-bottom: 1px solid #3dc4a7;
}

.el-icon-arrow-up:before {
  content: "\E6E1";
  position: relative;
  top: -6px;
}

.el-date-editor .el-icon-time {
  line-height: 22px;
}

.el-date-editor .el-range-separator {
  line-height: 22px;
}

.search {
  height: 36px;
  border-radius: 5px;
  background: #F2F2F3;
  margin-right: 20px;
}

.search-input {
  width: 100px;
  height: 100%;
  outline: none;
  transition: width ease .3s;
  background: transparent;
  padding: 0 5px;
  border: 0;
  box-sizing: border-box;
  line-height: 36px;
  font-size: 14px;
  margin-right: 5px;
}

.search-button {
  padding: 0 10px;
  height: 100%;
}

.search-button img {
  width: 15px;
  height: 16px;
}

.header-row-class-name .cell {
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 300;
  color: #999999;
  line-height: 17px;
}

.el-table .selected {
  background: #CFF1E9 !important;
}

.el-table--striped .el-table__body tr.selected td {
  background: #CFF1E9 !important;
}

.total-data {
  position: absolute;
  right: 0;
  top: 0;
  max-width: 85%;
  height: 40px;
  padding-right: 20px;
  box-sizing: border-box;
  z-index: 10;
}

.selected-data {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  z-index: 10;
  background: #B1CAF1;
}
</style>


// WEBPACK FOOTER //
// src/components/list/reports.vue